export default __webpack_public_path__ + "static/media/mashing.74498967.jpg";